document.addEventListener('DOMContentLoaded', function() {
  // Wait for DOM to be ready
  setTimeout(function() {
    // Check if swiper elements exist
    const heroSwiperEl = document.querySelector('.swiper-hero-banner');
    const textSwiperEl = document.querySelector('.swiper-text-content');
    
    if (!heroSwiperEl || !textSwiperEl) {
      return;
    }

    // Initialize Hero Banner Swiper (Images/Videos)
    var swiper1 = new Swiper('.swiper-hero-banner', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      on: {
        slideChange: function() {
          updateProgressBar(this.realIndex, this.slides.length);
          updateGradientOverlay(this);
        },
        init: function() {
          updateProgressBar(0, this.slides.length);
          updateGradientOverlay(this);
        }
      }
    });

    // Function to update gradient overlay based on active slide
    function updateGradientOverlay(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) {
        const color1 = activeSlide.getAttribute('data-color-1') || '#8B5628';
        const opacity1 = activeSlide.getAttribute('data-opacity-1') || '0.46';
        const color2 = activeSlide.getAttribute('data-color-2') || '#786148';
        const opacity2Start = activeSlide.getAttribute('data-opacity-2-start') || '0';
        const opacity2End = activeSlide.getAttribute('data-opacity-2-end') || '0.4';
        
        // Convert hex to RGB
        const hexToRgb = (hex) => {
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        };
        
        const rgb1 = hexToRgb(color1);
        const rgb2 = hexToRgb(color2);
        
        if (rgb1 && rgb2) {
          const gradient = `linear-gradient(0deg, rgba(${rgb1.r}, ${rgb1.g}, ${rgb1.b}, ${opacity1}), rgba(${rgb1.r}, ${rgb1.g}, ${rgb1.b}, ${opacity1})), linear-gradient(90deg, rgba(${rgb2.r}, ${rgb2.g}, ${rgb2.b}, ${opacity2Start}) 31.29%, rgba(${rgb2.r}, ${rgb2.g}, ${rgb2.b}, ${opacity2End}) 63.73%)`;
          activeSlide.style.setProperty('--slide-gradient', gradient);
        }
      }
    }

    // Initialize Text Content Swiper
    var swiper2 = new Swiper('.swiper-text-content', {
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 0
    });

    // Link them together using the controller property
    swiper1.controller.control = swiper2;
    swiper2.controller.control = swiper1;

    // Progress bar functionality
    function updateProgressBar(currentIndex, totalSlides) {
      const progressBar = document.querySelector('.hero-banner-section__progress-bar-inner');
      if (progressBar) {
        const progress = ((currentIndex + 1) / totalSlides) * 100;
        progressBar.style.width = progress + '%';
      }
    }

    // Animated progress bar for autoplay
    function startProgressAnimation() {
      const progressBar = document.querySelector('.hero-banner-section__progress-bar-inner');
      if (progressBar) {
        progressBar.style.transition = 'width 5s linear';
        progressBar.style.width = '100%';
      }
    }

    function resetProgressAnimation() {
      const progressBar = document.querySelector('.hero-banner-section__progress-bar-inner');
      if (progressBar) {
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';
        setTimeout(() => {
          startProgressAnimation();
        }, 50);
      }
    }

    // Start progress animation
    startProgressAnimation();

    // Reset progress on slide change
    swiper1.on('slideChange', function() {
      resetProgressAnimation();
    });

    // Handle navigation button clicks
    const nextButton = document.querySelector('.swiper-button-next-text');
    const prevButton = document.querySelector('.swiper-button-prev-text');

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        swiper1.slideNext();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        swiper1.slidePrev();
      });
    }

  }, 500);
});